import { render, staticRenderFns } from "./FinancesExpenses.vue?vue&type=template&id=87cc3286&scoped=true&"
import script from "./FinancesExpenses.vue?vue&type=script&lang=js&"
export * from "./FinancesExpenses.vue?vue&type=script&lang=js&"
import style0 from "./FinancesExpenses.vue?vue&type=style&index=0&id=87cc3286&scoped=true&lang=css&"
import style1 from "./FinancesExpenses.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cc3286",
  null
  
)

export default component.exports